import React, { type FC, memo } from "react";
import { Spinner } from "@heroui/react";

interface LoadingOverlayProps {
    isLoading: boolean;
    label?: React.ReactNode;
}

const LoadingOverlayImpl: FC<LoadingOverlayProps> = ({ isLoading, label }) => {
    if (!isLoading) {
        return null;
    }

    return (
        <div className="absolute inset-0 bg-app-surface/50 flex flex-col gap-2 items-center justify-center z-10">
            <Spinner size="lg" />
            {label ? <div className="text-app-text text-sm opacity-70">{label}</div> : null}
        </div>
    );
};

export const LoadingOverlay = memo(LoadingOverlayImpl);
